<template>
  <v-tabs v-model="activeTab" color="primary accent-4">
    <v-tab>Types</v-tab>
    <v-tab>Categories</v-tab>
    <v-tab>Items</v-tab>

    <v-tab-item>
      <cms-types />
    </v-tab-item>
    <v-tab-item>
      <cms-categories />
    </v-tab-item>
    <v-tab-item>
      <cms-items ref="items" :initial-type-slug="typeSlug" />
    </v-tab-item>
  </v-tabs>
</template>

<script>
export default {
  components: {
    CmsTypes: () => import('@/components/cms/types/CmsTypes'),
    CmsCategories: () => import('@/components/cms/categories/CmsCategories'),
    CmsItems: () => import('@/components/cms/items/Items'),
  },
  data() {
    return {
      activeTab: 0,
    }
  },
  computed: {
    typeSlug() {
      return this.$route.params.typeSlug || null
    },
  },
  watch: {
    typeSlug: {
      immediate: true,
      handler(slug) {
        if (slug) {
          this.activeTab = 2
        }
      },
    },
  },
}
</script>